import React, { FC } from 'react';
import { Field } from 'redux-form';
import moment from 'moment-timezone';
import { useTranslations } from '@lang';
import { Calendar } from '@common/components/Calendar';
import { Text } from '@common/components/Typography';

import { SelectDateWrapper, ChangeDate } from './SelectDate.styles';
import { indexFieldName } from '../services';
import { BASKET_VALID_FROM } from './constants';
import { FulfilableBasketItemType } from '@features/AddedToBasket/Fulfilable/FulfilableAddedToBasket.types';

export type SelectDateProps = {
  type: FulfilableBasketItemType;
  member: string;
};

const date = moment();
export const FORMAT = 'dddd DD MMMM YYYY';

export const SelectDate: FC<SelectDateProps> = ({ type, member }) => {
  const { t } = useTranslations();

  return type === 'voucher' ? (
    <ChangeDate>
      <Text isSmall isSecondary>
        {t('personalization.changeDateText')}
      </Text>
      <SelectDateWrapper>
        <Field
          id="calendar"
          name={indexFieldName(member, BASKET_VALID_FROM)}
          label={t('personalization.validFrom')}
          component={Calendar}
          dateFormat={FORMAT}
          minDate={date}
        />
      </SelectDateWrapper>
    </ChangeDate>
  ) : null;
};
